import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from './fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<User>;
  country: Country;
  postCode: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  streetLine1: Scalars['String']['output'];
  streetLine2?: Maybe<Scalars['String']['output']>;
};

export type AdjustableProductAndService = {
  __typename?: 'AdjustableProductAndService';
  decrease: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  increase: Scalars['Boolean']['output'];
  isDigital?: Maybe<Scalars['Boolean']['output']>;
  productTranslationKey: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type Appointment = {
  __typename?: 'Appointment';
  candidate: Candidate;
  id: Scalars['String']['output'];
  status: AppointmentStatusEnum;
};

export type AppointmentScoringFilters = {
  statuses?: InputMaybe<Array<AppointmentStatusEnum>>;
};

export enum AppointmentStatusEnum {
  StatusAccepted = 'STATUS_ACCEPTED',
  StatusCancelled = 'STATUS_CANCELLED',
  StatusCancelledByClient = 'STATUS_CANCELLED_BY_CLIENT',
  StatusCancelledWithPromoCode = 'STATUS_CANCELLED_WITH_PROMO_CODE',
  StatusExpected = 'STATUS_EXPECTED',
  StatusNoShow = 'STATUS_NO_SHOW',
  StatusPending = 'STATUS_PENDING',
  StatusRefused = 'STATUS_REFUSED'
}

export enum BusinessStatusEnum {
  ClientActive = 'CLIENT_ACTIVE',
  ClientArchived = 'CLIENT_ARCHIVED',
  ClientInactive = 'CLIENT_INACTIVE',
  ClientSuspensionLevel_1 = 'CLIENT_SUSPENSION_LEVEL_1',
  ClientSuspensionLevel_2 = 'CLIENT_SUSPENSION_LEVEL_2',
  ClientSuspensionLevel_3 = 'CLIENT_SUSPENSION_LEVEL_3',
  ClientTerminatedByEtsGbv = 'CLIENT_TERMINATED_BY_ETS_GBV'
}

export type Candidate = {
  __typename?: 'Candidate';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  identificationId?: Maybe<Scalars['String']['output']>;
  /** use only for Session */
  includedProductsAndServices?: Maybe<Array<Maybe<CandidateIncludedProductAndService>>>;
  lastName?: Maybe<Scalars['String']['output']>;
  pictureUrl?: Maybe<Scalars['String']['output']>;
  /** use only for Session */
  productsAndServices?: Maybe<Array<Maybe<CandidateProductAndService>>>;
  token?: Maybe<Scalars['String']['output']>;
};

export type CandidateIncludedProductAndService = {
  __typename?: 'CandidateIncludedProductAndService';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  requiresScoreReport: Scalars['Boolean']['output'];
  translationKey: Scalars['String']['output'];
};

export type CandidateProductAndService = {
  __typename?: 'CandidateProductAndService';
  id: Scalars['Int']['output'];
  logisticCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  translationKey: Scalars['String']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  category: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastUpdatedAt?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export enum CommentCategory {
  GeneralInformation = 'GENERAL_INFORMATION',
  InstructionForLogisticsAfterLock = 'INSTRUCTION_FOR_LOGISTICS_AFTER_LOCK',
  InstructionForLogisticsBeforeLock = 'INSTRUCTION_FOR_LOGISTICS_BEFORE_LOCK',
  InstructionForScoring = 'INSTRUCTION_FOR_SCORING'
}

export type CommentInput = {
  category: CommentCategory;
  message: Scalars['String']['input'];
};

export type Country = {
  __typename?: 'Country';
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
};

export type FileInput = {
  content: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type IopsScore = {
  __typename?: 'IopsScore';
  resultNumber: Scalars['Int']['output'];
};

export type LsdAddress = {
  __typename?: 'LSDAddress';
  city: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
};

export type LsdCandidateInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  identificationId?: InputMaybe<Scalars['Int']['input']>;
  lastName: Scalars['String']['input'];
};

export type LsdCandidateNameResponse = {
  __typename?: 'LSDCandidateNameResponse';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
};

export type LsdCandidateResponse = {
  __typename?: 'LSDCandidateResponse';
  dateOfBirth: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type LsdClientData = {
  __typename?: 'LSDClientData';
  clientId: Scalars['Int']['output'];
  clientName: Scalars['String']['output'];
};

export type LsdCriteriaInput = {
  lsdFamily: LsdFamily;
  threshold: Scalars['Int']['input'];
};

export type LsdDataResponse = {
  __typename?: 'LSDDataResponse';
  dateDifference: Scalars['Int']['output'];
  scoreDifference: Scalars['Int']['output'];
};

export type LsdInput = {
  criteria: LsdCriteriaInput;
  scores: Array<LsdScoreInput>;
  sessionEndAt: Scalars['String']['input'];
};

export type LsdPreviousScoreResponse = {
  __typename?: 'LSDPreviousScoreResponse';
  blankAnswers?: Maybe<Scalars['Int']['output']>;
  candidateName: LsdCandidateNameResponse;
  clientData?: Maybe<LsdClientData>;
  lsd: LsdDataResponse;
  score: Array<ScoreType>;
  session: LsdSessionResponse;
  test: LsdTestResponse;
};

export type LsdResponse = {
  __typename?: 'LSDResponse';
  candidate: LsdCandidateResponse;
  previousScores: Array<LsdPreviousScoreResponse>;
  rowNumber: Scalars['Int']['output'];
  totalScore: Scalars['Int']['output'];
};

export type LsdScoreInput = {
  candidate: LsdCandidateInput;
  rowNumber: Scalars['Int']['input'];
  totalScore: Scalars['Int']['input'];
};

export type LsdSessionResponse = {
  __typename?: 'LSDSessionResponse';
  sessionDate: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  testingSite?: Maybe<LsdTestingSite>;
};

export type LsdTestResponse = {
  __typename?: 'LSDTestResponse';
  deliveryPlatform: Scalars['Int']['output'];
  formVersion: Scalars['String']['output'];
  format: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  open?: Maybe<Scalars['Int']['output']>;
  program?: Maybe<Scalars['Int']['output']>;
  type: SessionType;
};

export type LsdTestingSite = {
  __typename?: 'LSDTestingSite';
  address: LsdAddress;
};

export enum LsdFamily {
  LsdFamilyTfi = 'LSD_FAMILY_TFI',
  LsdFamilyToefl = 'LSD_FAMILY_TOEFL',
  LsdFamilyToeic = 'LSD_FAMILY_TOEIC'
}

export type MatchedScore = {
  externalCandidateId?: InputMaybe<Scalars['String']['input']>;
  identificationId?: InputMaybe<Scalars['String']['input']>;
  rowNumber: Scalars['Int']['input'];
  scoreStatus: ScoreStatusEnum;
};

export type Matching = {
  __typename?: 'Matching';
  externalCandidateId?: Maybe<Scalars['String']['output']>;
  reason: MatchingReason;
  rowNumber: Scalars['Int']['output'];
};

export enum MatchingReason {
  Custom = 'CUSTOM',
  Id = 'ID',
  Name = 'NAME',
  NameAndDateOfBirth = 'NAME_AND_DATE_OF_BIRTH',
  NameAndId = 'NAME_AND_ID',
  SimilarNameAndDateOfBirth = 'SIMILAR_NAME_AND_DATE_OF_BIRTH'
}

export type Mutation = {
  __typename?: 'Mutation';
  addComment: Comment;
  auth: Scalars['String']['output'];
  confirmScoring: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  logout: Scalars['Boolean']['output'];
  lsd: Array<LsdResponse>;
  parseIopsFile: UploadScoreResult;
  saveScoreMatching: Scalars['Boolean']['output'];
  updateBusinessOnAuth: Scalars['Boolean']['output'];
  updateCandidatePhoto: Scalars['Boolean']['output'];
  updateComment: Scalars['Boolean']['output'];
  updateScore: UpdateScoreResult;
  updateScores: UpdateScoresResult;
  updateSessionPrintingStatus: Scalars['Boolean']['output'];
};


export type MutationAddCommentArgs = {
  businessId: Scalars['Int']['input'];
  comment: CommentInput;
  sessionId: Scalars['Int']['input'];
};


export type MutationAuthArgs = {
  password: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationConfirmScoringArgs = {
  businessId: Scalars['Int']['input'];
  plannedAt?: InputMaybe<Scalars['String']['input']>;
  purchaseAdjustment?: InputMaybe<PurchaseAdjustmentInput>;
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  scoredAt: Scalars['String']['input'];
  scorerId: Scalars['Int']['input'];
  scoringType?: InputMaybe<ScoringType>;
  sessionId: Scalars['Int']['input'];
};


export type MutationDeleteCommentArgs = {
  businessId: Scalars['Int']['input'];
  commentId: Scalars['String']['input'];
  sessionId: Scalars['Int']['input'];
};


export type MutationLsdArgs = {
  businessId: Scalars['Int']['input'];
  lsdInput: LsdInput;
  sessionId: Scalars['Int']['input'];
};


export type MutationParseIopsFileArgs = {
  businessId: Scalars['Int']['input'];
  context?: InputMaybe<UploadScoreContext>;
  file: FileInput;
  sessionId: Scalars['Int']['input'];
};


export type MutationSaveScoreMatchingArgs = {
  businessId: Scalars['Int']['input'];
  businessName: Scalars['String']['input'];
  file: FileInput;
  matchedScores: Array<MatchedScore>;
  sessionId: Scalars['Int']['input'];
};


export type MutationUpdateBusinessOnAuthArgs = {
  businessId: Scalars['Int']['input'];
};


export type MutationUpdateCandidatePhotoArgs = {
  candidateToken: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  photoContent: Scalars['String']['input'];
};


export type MutationUpdateCommentArgs = {
  businessId: Scalars['Int']['input'];
  comment: CommentInput;
  commentId: Scalars['String']['input'];
  sessionId: Scalars['Int']['input'];
};


export type MutationUpdateScoreArgs = {
  businessId: Scalars['Int']['input'];
  fileContents: Scalars['String']['input'];
  scoreId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
};


export type MutationUpdateScoresArgs = {
  businessId: Scalars['Int']['input'];
  scores: Array<InputMaybe<StoredScoreInput>>;
  sessionId: Scalars['Int']['input'];
};


export type MutationUpdateSessionPrintingStatusArgs = {
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
  transition: Scalars['String']['input'];
};

export type NameAtExam = {
  __typename?: 'NameAtExam';
  firstName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export type NumberOfIopsRowsAndPendingScores = {
  __typename?: 'NumberOfIopsRowsAndPendingScores';
  numberOfRows?: Maybe<Scalars['Int']['output']>;
  pendingScores?: Maybe<Scalars['Int']['output']>;
};

export type PlannedDates = {
  __typename?: 'PlannedDates';
  availableDates: Array<Scalars['String']['output']>;
  defaultDate?: Maybe<Scalars['String']['output']>;
};

export type ProductServiceAdjustmentInput = {
  productAndService: Scalars['Int']['input'];
  quantity: Scalars['Int']['input'];
};

export type Purchase = {
  __typename?: 'Purchase';
  id: Scalars['Int']['output'];
  isAwaitingInvoicingOrBilled: Scalars['Boolean']['output'];
  isEditable: Scalars['Boolean']['output'];
};

export type PurchaseAdjustmentInput = {
  numberOfCandidatesToInvoice: Scalars['Int']['input'];
  productAndServiceAdjustmentsInformation: Array<ProductServiceAdjustmentInput>;
};

export type QualityControl = {
  __typename?: 'QualityControl';
  identicalNameGroup?: Maybe<Scalars['Int']['output']>;
  identicalScoreGroup?: Maybe<Scalars['Int']['output']>;
  lowScore: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  appointmentsForScoring: Array<Appointment>;
  getSessionsAllowedToPrint: SessionList;
  getSessionsAllowedToScore: SessionList;
  getUsersForBusiness: Array<User>;
  loadSessionForScoring: Session;
  me: User;
  numberOfIopsRowsAndPendingScores: NumberOfIopsRowsAndPendingScores;
  scoringValidationDefaults: ScoringValidationDefaults;
  storedScore: StoredScore;
  storedScores: StoredScoreList;
};


export type QueryAppointmentsForScoringArgs = {
  businessId: Scalars['Int']['input'];
  filters?: InputMaybe<AppointmentScoringFilters>;
  sessionId: Scalars['Int']['input'];
};


export type QueryGetSessionsAllowedToPrintArgs = {
  businessId: Scalars['Int']['input'];
  filters?: InputMaybe<SessionPrintingFiltersInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: SortInput;
};


export type QueryGetSessionsAllowedToScoreArgs = {
  businessId: Scalars['Int']['input'];
  filters?: InputMaybe<SessionScoringFiltersInput>;
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
  sort?: SortInput;
};


export type QueryGetUsersForBusinessArgs = {
  businessId: Scalars['Int']['input'];
  roles?: InputMaybe<Array<UserRolesEnum>>;
  sort?: InputMaybe<SortInput>;
};


export type QueryLoadSessionForScoringArgs = {
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
};


export type QueryNumberOfIopsRowsAndPendingScoresArgs = {
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
};


export type QueryScoringValidationDefaultsArgs = {
  businessId: Scalars['Int']['input'];
  isNumberMode?: InputMaybe<Scalars['Boolean']['input']>;
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  scoringType: ScoringType;
  sessionId: Scalars['Int']['input'];
};


export type QueryStoredScoreArgs = {
  businessId: Scalars['Int']['input'];
  scoreId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
};


export type QueryStoredScoresArgs = {
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
};

export enum ScoreStatusEnum {
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE',
  UnderAdminReview = 'UNDER_ADMIN_REVIEW',
  Valid = 'VALID'
}

export type ScoreType = {
  __typename?: 'ScoreType';
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type ScoredCandidate = {
  __typename?: 'ScoredCandidate';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formCode: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  identificationId?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  qualityControl: QualityControl;
  resultNumber: Scalars['Int']['output'];
  rowNumber: Scalars['Float']['output'];
  scores: Array<ScoreType>;
  totalScore: Scalars['Int']['output'];
};

export type ScoringDocsMailDelivery = {
  __typename?: 'ScoringDocsMailDelivery';
  expressAt?: Maybe<Scalars['String']['output']>;
  standardAt?: Maybe<Scalars['String']['output']>;
  superExpressAt?: Maybe<Scalars['String']['output']>;
};

export type ScoringDocuments = {
  __typename?: 'ScoringDocuments';
  allCandidatesCertificateUrl?: Maybe<Scalars['String']['output']>;
  allCandidatesIPFUrl?: Maybe<Scalars['String']['output']>;
  allCandidatesScoreReportUrl?: Maybe<Scalars['String']['output']>;
  combinedCertificateFileUrl?: Maybe<Scalars['String']['output']>;
  combinedIPFFileUrl?: Maybe<Scalars['String']['output']>;
  expressScoreRosterUpdatedAt?: Maybe<Scalars['String']['output']>;
  expressScoreRosterUrl?: Maybe<Scalars['String']['output']>;
  postMatchedStickersFileUrl?: Maybe<Scalars['String']['output']>;
  scoreReportUrl?: Maybe<Scalars['String']['output']>;
  standardScoreRosterUpdatedAt?: Maybe<Scalars['String']['output']>;
  standardScoreRosterUrl?: Maybe<Scalars['String']['output']>;
  stickersFileUrl?: Maybe<Scalars['String']['output']>;
};

export enum ScoringType {
  Express = 'EXPRESS',
  Standard = 'STANDARD',
  SuperExpress = 'SUPER_EXPRESS'
}

export type ScoringValidationDefaults = {
  __typename?: 'ScoringValidationDefaults';
  adjustedProducts?: Maybe<Array<Maybe<AdjustableProductAndService>>>;
  candidatesCPFWithScoreUnderA2No: Scalars['Int']['output'];
  originalPurchasedTestTypeQuantity?: Maybe<Scalars['Int']['output']>;
  plannedDates: PlannedDates;
  purchase?: Maybe<Purchase>;
  realCandidatesNo: Scalars['Int']['output'];
};

export type Session = {
  __typename?: 'Session';
  business: SessionBusiness;
  canHaveExternalCandidateIdInIopsFile?: Maybe<Scalars['Boolean']['output']>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  country: Country;
  documents?: Maybe<ScoringDocuments>;
  endAt?: Maybe<Scalars['String']['output']>;
  expectedCandidates?: Maybe<Scalars['Float']['output']>;
  hasCandidateIdInIopsFile?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isCmd?: Maybe<Scalars['Boolean']['output']>;
  isNumberMode: Scalars['Boolean']['output'];
  isOpen: Scalars['Boolean']['output'];
  logisticsPlannedDatesDocsDelivery?: Maybe<ScoringDocsMailDelivery>;
  logisticsReceived?: Maybe<SessionLogisticsReceived>;
  printing?: Maybe<SessionPrinting>;
  purchase?: Maybe<Purchase>;
  resultsShippingAddress?: Maybe<Address>;
  scheduledAt: Scalars['String']['output'];
  scoring?: Maybe<SessionScoring>;
  scoringType?: Maybe<Scalars['String']['output']>;
  shouldBeManagedInTasPortal?: Maybe<Scalars['Boolean']['output']>;
  status: SessionStatus;
  testType: TestType;
  testingSite?: Maybe<TestingSite>;
  totalScores?: Maybe<Scalars['Float']['output']>;
};

export type SessionBusiness = {
  __typename?: 'SessionBusiness';
  erpId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<BusinessStatusEnum>;
};

export type SessionCandidateWithMatch = {
  __typename?: 'SessionCandidateWithMatch';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  identificationId: Scalars['String']['output'];
  matching?: Maybe<Matching>;
};

export type SessionList = {
  __typename?: 'SessionList';
  results?: Maybe<Array<Maybe<Session>>>;
  total: Scalars['Int']['output'];
};

export type SessionLogisticsReceived = {
  __typename?: 'SessionLogisticsReceived';
  quantityAnswerSheetsToBeScored?: Maybe<Scalars['Int']['output']>;
  receiptDate?: Maybe<Scalars['String']['output']>;
};

export type SessionPrinting = {
  __typename?: 'SessionPrinting';
  status?: Maybe<SessionPrintingStatus>;
};

export type SessionPrintingFiltersInput = {
  printingStatus?: InputMaybe<SessionPrintingStatus>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
};

export enum SessionPrintingStatus {
  NotPrinted = 'NOT_PRINTED',
  Printed = 'PRINTED'
}

export type SessionScoring = {
  __typename?: 'SessionScoring';
  iopsNumber?: Maybe<Scalars['String']['output']>;
  scoredAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SessionScoringStatus>;
};

export type SessionScoringFiltersInput = {
  scoringListingStatus?: InputMaybe<SessionScoringListingStatus>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  testTypeFormat?: InputMaybe<TestTypeFormatEnum>;
};

export enum SessionScoringListingStatus {
  All = 'ALL',
  NoFilter = 'NO_FILTER',
  Ready = 'READY',
  Scored = 'SCORED'
}

export enum SessionScoringStatus {
  Finished = 'FINISHED',
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED'
}

export enum SessionStatus {
  Administered = 'ADMINISTERED',
  AwaitingPptcValidation = 'AWAITING_PPTC_VALIDATION',
  Blocked = 'BLOCKED',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Empty = 'EMPTY',
  FailedOrders = 'FAILED_ORDERS',
  Incomplete = 'INCOMPLETE',
  Locked = 'LOCKED',
  LogisticsDone = 'LOGISTICS_DONE',
  LogisticsLocked = 'LOGISTICS_LOCKED',
  LogisticsPending = 'LOGISTICS_PENDING',
  OpenForRegistration = 'OPEN_FOR_REGISTRATION',
  PendingExternal = 'PENDING_EXTERNAL',
  PendingInternal = 'PENDING_INTERNAL',
  Preparing = 'PREPARING',
  Received = 'RECEIVED',
  Scheduled = 'SCHEDULED',
  Scored = 'SCORED',
  Shipped = 'SHIPPED',
  TakenIntoAccount = 'TAKEN_INTO_ACCOUNT'
}

export enum SessionType {
  Inhouse = 'INHOUSE',
  Open = 'OPEN'
}

export type SortInput = {
  field: Scalars['String']['input'];
  order: SortOrderEnum;
};

export enum SortOrderEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StoredCandidate = {
  __typename?: 'StoredCandidate';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  identificationId?: Maybe<Scalars['String']['output']>;
  nameAtExam?: Maybe<NameAtExam>;
};

export type StoredScore = {
  __typename?: 'StoredScore';
  candidate: StoredCandidate;
  details?: Maybe<Array<Maybe<ScoreType>>>;
  id: Scalars['Int']['output'];
  iopsScore?: Maybe<IopsScore>;
  isCpfWithMinimumCefrLevel: Scalars['Boolean']['output'];
  status: ScoreStatusEnum;
  test?: Maybe<Test>;
};

export type StoredScoreInput = {
  id: Scalars['Float']['input'];
  status: ScoreStatusEnum;
};

export type StoredScoreList = {
  __typename?: 'StoredScoreList';
  results: Array<StoredScore>;
  total: Scalars['Int']['output'];
};

export type Test = {
  __typename?: 'Test';
  formVersion?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
};

export type TestType = {
  __typename?: 'TestType';
  formVersion?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isCbt?: Maybe<Scalars['Boolean']['output']>;
  isPbt?: Maybe<Scalars['Boolean']['output']>;
  lsdFamily?: Maybe<LsdFamily>;
  lsdThreshold?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  open: Scalars['Boolean']['output'];
  translationKey?: Maybe<Scalars['String']['output']>;
};

export enum TestTypeFormatEnum {
  FormatCbt = 'FORMAT_CBT',
  FormatPbt = 'FORMAT_PBT'
}

export type TestingSite = {
  __typename?: 'TestingSite';
  address: Address;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UpdateScoreError = {
  __typename?: 'UpdateScoreError';
  code: Scalars['Int']['output'];
  error: UpdateScoreErrorCode;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum UpdateScoreErrorCode {
  BadRequest = 'BAD_REQUEST',
  DuplicateResultNumber = 'DUPLICATE_RESULT_NUMBER',
  InternalServerError = 'INTERNAL_SERVER_ERROR'
}

export type UpdateScoreResult = UpdateScoreError | UpdateScoreSuccess;

export type UpdateScoreSuccess = {
  __typename?: 'UpdateScoreSuccess';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateScoresError = {
  __typename?: 'UpdateScoresError';
  code: Scalars['Int']['output'];
  error: UpdateScoresErrorCode;
  scoreIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export enum UpdateScoresErrorCode {
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  InvalidScores = 'INVALID_SCORES',
  InvalidTransitionScores = 'INVALID_TRANSITION_SCORES'
}

export type UpdateScoresErrorList = {
  __typename?: 'UpdateScoresErrorList';
  errors?: Maybe<Array<Maybe<UpdateScoresError>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateScoresResult = UpdateScoresErrorList | UpdateScoresSuccess;

export type UpdateScoresSuccess = {
  __typename?: 'UpdateScoresSuccess';
  scores?: Maybe<Array<Maybe<StoredScore>>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum UploadScoreContext {
  ParsingOnly = 'PARSING_ONLY',
  Scoring = 'SCORING'
}

export type UploadScoreError = {
  __typename?: 'UploadScoreError';
  code: UploadScoreErrorCode;
  errors: UploadScoreParseError;
};

export enum UploadScoreErrorCode {
  InvalidFile = 'INVALID_FILE',
  InvalidFileDuplicateCandidateIds = 'INVALID_FILE_DUPLICATE_CANDIDATE_IDS',
  InvalidFileDuplicateResultIds = 'INVALID_FILE_DUPLICATE_RESULT_IDS',
  InvalidFileMissingColumns = 'INVALID_FILE_MISSING_COLUMNS',
  InvalidRows = 'INVALID_ROWS'
}

export type UploadScoreParseError = {
  __typename?: 'UploadScoreParseError';
  invalidRows: Array<Scalars['Int']['output']>;
};

export type UploadScoreResult = UploadScoreError | UploadScoreSuccess;

export type UploadScoreSuccess = {
  __typename?: 'UploadScoreSuccess';
  scoredCandidates: Array<ScoredCandidate>;
  sessionCandidates: Array<SessionCandidateWithMatch>;
};

export type User = {
  __typename?: 'User';
  businessId?: Maybe<Scalars['Int']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstname?: Maybe<Scalars['String']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isB2B: Scalars['Boolean']['output'];
  lastname?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<UserRolesEnum>>;
};

export enum UserRolesEnum {
  RoleAccountant = 'ROLE_ACCOUNTANT',
  RoleAdmin = 'ROLE_ADMIN',
  RoleBecomeUser = 'ROLE_BECOME_USER',
  RoleInvoicer = 'ROLE_INVOICER',
  RoleLegalRepresentative = 'ROLE_LEGAL_REPRESENTATIVE',
  RoleProctor = 'ROLE_PROCTOR',
  RolePurchaser = 'ROLE_PURCHASER',
  RoleScorer = 'ROLE_SCORER',
  RoleTca = 'ROLE_TCA',
  RoleUser = 'ROLE_USER'
}

export type AddCommentMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
  comment: CommentInput;
}>;


export type AddCommentMutation = { __typename?: 'Mutation', addComment: { __typename?: 'Comment', category: string, id: string, lastUpdatedAt?: string | null, message: string, username?: string | null } };

export type ConfirmScoringMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  plannedAt?: InputMaybe<Scalars['String']['input']>;
  purchaseAdjustment?: InputMaybe<PurchaseAdjustmentInput>;
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  scoredAt: Scalars['String']['input'];
  scorerId: Scalars['Int']['input'];
  scoringType?: InputMaybe<ScoringType>;
  sessionId: Scalars['Int']['input'];
}>;


export type ConfirmScoringMutation = { __typename?: 'Mutation', confirmScoring: boolean };

export type DeleteCommentMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
  commentId: Scalars['String']['input'];
}>;


export type DeleteCommentMutation = { __typename?: 'Mutation', deleteComment: boolean };

export type AuthMutationVariables = Exact<{
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
  recaptchaToken: Scalars['String']['input'];
}>;


export type AuthMutation = { __typename?: 'Mutation', auth: string };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout: boolean };

export type GetLsdMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  lsdInput: LsdInput;
  sessionId: Scalars['Int']['input'];
}>;


export type GetLsdMutation = { __typename?: 'Mutation', lsd: Array<{ __typename?: 'LSDResponse', rowNumber: number, totalScore: number, candidate: { __typename?: 'LSDCandidateResponse', dateOfBirth: string, firstName: string, lastName: string }, previousScores: Array<{ __typename?: 'LSDPreviousScoreResponse', blankAnswers?: number | null, candidateName: { __typename?: 'LSDCandidateNameResponse', firstName?: string | null, lastName: string }, clientData?: { __typename?: 'LSDClientData', clientId: number, clientName: string } | null, lsd: { __typename?: 'LSDDataResponse', dateDifference: number, scoreDifference: number }, score: Array<{ __typename?: 'ScoreType', type: string, value?: number | null }>, session: { __typename?: 'LSDSessionResponse', sessionDate: string, sessionId: string, testingSite?: { __typename?: 'LSDTestingSite', address: { __typename?: 'LSDAddress', city: string, postCode: string } } | null }, test: { __typename?: 'LSDTestResponse', deliveryPlatform: number, formVersion: string, format: number, id?: number | null, name?: string | null, open?: number | null, program?: number | null, type: SessionType } }> }> };

export type SaveScoresMutationVariables = Exact<{
  file: FileInput;
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
  matchedScores: Array<MatchedScore> | MatchedScore;
  businessName: Scalars['String']['input'];
}>;


export type SaveScoresMutation = { __typename?: 'Mutation', isSaved: boolean };

export type UpdateBusinessOnAuthMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
}>;


export type UpdateBusinessOnAuthMutation = { __typename?: 'Mutation', updateCompleted: boolean };

export type UpdateCommentMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
  commentId: Scalars['String']['input'];
  comment: CommentInput;
}>;


export type UpdateCommentMutation = { __typename?: 'Mutation', updateComment: boolean };

export type UpdateScoresMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
  scores: Array<InputMaybe<StoredScoreInput>> | InputMaybe<StoredScoreInput>;
}>;


export type UpdateScoresMutation = { __typename?: 'Mutation', updateScores: { __typename?: 'UpdateScoresErrorList', success?: boolean | null, errors?: Array<{ __typename?: 'UpdateScoresError', code: number, error: UpdateScoresErrorCode, scoreIds?: Array<number | null> | null } | null> | null } | { __typename?: 'UpdateScoresSuccess', success?: boolean | null, scores?: Array<{ __typename?: 'StoredScore', id: number, status: ScoreStatusEnum } | null> | null } };

export type UpdateSessionPrintingStatusMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
  transition: Scalars['String']['input'];
}>;


export type UpdateSessionPrintingStatusMutation = { __typename?: 'Mutation', updateSessionPrintingStatus: boolean };

export type UpdateScoreMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  fileContents: Scalars['String']['input'];
  scoreId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
}>;


export type UpdateScoreMutation = { __typename?: 'Mutation', updateScore: { __typename?: 'UpdateScoreError', code: number, error: UpdateScoreErrorCode, success?: boolean | null } | { __typename?: 'UpdateScoreSuccess', success?: boolean | null } };

export type UploadScoreMutationVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
  file: FileInput;
  context?: InputMaybe<UploadScoreContext>;
}>;


export type UploadScoreMutation = { __typename?: 'Mutation', parseIopsFile: { __typename: 'UploadScoreError', errorCode: UploadScoreErrorCode, errors: { __typename?: 'UploadScoreParseError', invalidRows: Array<number> } } | { __typename: 'UploadScoreSuccess', scoredCandidates: Array<{ __typename?: 'ScoredCandidate', identificationId?: string | null, fullName?: string | null, firstName?: string | null, lastName?: string | null, dateOfBirth?: string | null, totalScore: number, resultNumber: number, rowNumber: number, formCode: string, scores: Array<{ __typename?: 'ScoreType', type: string, value?: number | null }>, qualityControl: { __typename?: 'QualityControl', identicalNameGroup?: number | null, identicalScoreGroup?: number | null, lowScore: boolean } }>, sessionCandidates: Array<{ __typename?: 'SessionCandidateWithMatch', dateOfBirth?: string | null, fullName: string, identificationId: string, matching?: { __typename?: 'Matching', externalCandidateId?: string | null, rowNumber: number, reason: MatchingReason } | null }> } };

export type GetSessionDetailsQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
}>;


export type GetSessionDetailsQuery = { __typename?: 'Query', loadSessionForScoring: { __typename?: 'Session', id: number, scheduledAt: string, isCmd?: boolean | null, status: SessionStatus, scoringType?: string | null, totalScores?: number | null, expectedCandidates?: number | null, business: { __typename?: 'SessionBusiness', id: number, name: string, erpId?: string | null, status?: BusinessStatusEnum | null }, country: { __typename?: 'Country', timezone: string }, comments?: Array<{ __typename?: 'Comment', category: string, id: string, lastUpdatedAt?: string | null, message: string, username?: string | null } | null> | null, testType: { __typename?: 'TestType', formVersion?: string | null, open: boolean, name: string, translationKey?: string | null, isPbt?: boolean | null }, scoring?: { __typename?: 'SessionScoring', iopsNumber?: string | null, scoredAt?: string | null, status?: SessionScoringStatus | null } | null, purchase?: { __typename?: 'Purchase', id: number } | null, testingSite?: { __typename?: 'TestingSite', name: string, address: { __typename?: 'Address', country: { __typename?: 'Country', name: string } } } | null, resultsShippingAddress?: { __typename?: 'Address', city: string, company?: string | null, postCode: string, state?: string | null, streetLine1: string, streetLine2?: string | null, country: { __typename?: 'Country', name: string }, contact?: { __typename?: 'User', name?: string | null, phoneNumber?: string | null, email?: string | null } | null } | null, logisticsPlannedDatesDocsDelivery?: { __typename?: 'ScoringDocsMailDelivery', standardAt?: string | null, expressAt?: string | null, superExpressAt?: string | null } | null, logisticsReceived?: { __typename?: 'SessionLogisticsReceived', quantityAnswerSheetsToBeScored?: number | null, receiptDate?: string | null } | null } };

export type GetSessionsAllowedToPrintQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  filters?: InputMaybe<SessionPrintingFiltersInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort: SortInput;
}>;


export type GetSessionsAllowedToPrintQuery = { __typename?: 'Query', getSessionsAllowedToPrint: { __typename?: 'SessionList', total: number, results?: Array<{ __typename?: 'Session', id: number, scheduledAt: string, country: { __typename?: 'Country', timezone: string }, testType: { __typename?: 'TestType', isCbt?: boolean | null, name: string, translationKey?: string | null } } | null> | null } };

export type GetSessionsAllowedToScoreQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  filters?: InputMaybe<SessionScoringFiltersInput>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  sort: SortInput;
}>;


export type GetSessionsAllowedToScoreQuery = { __typename?: 'Query', getSessionsAllowedToScore: { __typename?: 'SessionList', total: number, results?: Array<{ __typename?: 'Session', id: number, status: SessionStatus, scheduledAt: string, business: { __typename?: 'SessionBusiness', id: number, name: string }, country: { __typename?: 'Country', name: string, timezone: string }, testType: { __typename?: 'TestType', id: number, name: string, translationKey?: string | null }, purchase?: { __typename?: 'Purchase', id: number } | null } | null> | null } };

export type GetUsersForBusinessQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  roles?: InputMaybe<Array<UserRolesEnum> | UserRolesEnum>;
  sort?: InputMaybe<SortInput>;
}>;


export type GetUsersForBusinessQuery = { __typename?: 'Query', getUsersForBusiness: Array<{ __typename?: 'User', fullname?: string | null, id: number }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'User', id: number, email?: string | null, firstname?: string | null, lastname?: string | null, preferredLanguage?: string | null, businessId?: number | null, businessName?: string | null, roles?: Array<UserRolesEnum> | null, isB2B: boolean } };

export type NumberOfIopsRowsAndPendingScoresQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
}>;


export type NumberOfIopsRowsAndPendingScoresQuery = { __typename?: 'Query', numberOfIopsRowsAndPendingScores: { __typename?: 'NumberOfIopsRowsAndPendingScores', numberOfRows?: number | null, pendingScores?: number | null } };

export type ScoringValidationDefaultsQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  scoringType: ScoringType;
  sessionId: Scalars['Int']['input'];
  purchaseId?: InputMaybe<Scalars['Int']['input']>;
  isNumberMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ScoringValidationDefaultsQuery = { __typename?: 'Query', scoringValidationDefaults: { __typename?: 'ScoringValidationDefaults', originalPurchasedTestTypeQuantity?: number | null, realCandidatesNo: number, candidatesCPFWithScoreUnderA2No: number, plannedDates: { __typename?: 'PlannedDates', availableDates: Array<string>, defaultDate?: string | null }, adjustedProducts?: Array<{ __typename?: 'AdjustableProductAndService', id: number, decrease: boolean, increase: boolean, isDigital?: boolean | null, productTranslationKey: string, quantity: number, unitPrice: number } | null> | null, purchase?: { __typename?: 'Purchase', isAwaitingInvoicingOrBilled: boolean, isEditable: boolean } | null } };

export type LoadSessionForScoringQueryVariables = Exact<{
  businessId: Scalars['Int']['input'];
  sessionId: Scalars['Int']['input'];
}>;


export type LoadSessionForScoringQuery = { __typename?: 'Query', loadSessionForScoring: { __typename?: 'Session', canHaveExternalCandidateIdInIopsFile?: boolean | null, shouldBeManagedInTasPortal?: boolean | null, hasCandidateIdInIopsFile?: boolean | null, id: number, isCmd?: boolean | null, isOpen: boolean, scoringType?: string | null, isNumberMode: boolean, scheduledAt: string, endAt?: string | null, status: SessionStatus, business: { __typename?: 'SessionBusiness', id: number, name: string }, country: { __typename?: 'Country', name: string, timezone: string }, scoring?: { __typename?: 'SessionScoring', status?: SessionScoringStatus | null } | null, testType: { __typename?: 'TestType', formVersion?: string | null, id: number, name: string, open: boolean, lsdThreshold?: number | null, lsdFamily?: LsdFamily | null, isCbt?: boolean | null }, purchase?: { __typename?: 'Purchase', id: number } | null, printing?: { __typename?: 'SessionPrinting', status?: SessionPrintingStatus | null } | null, logisticsReceived?: { __typename?: 'SessionLogisticsReceived', quantityAnswerSheetsToBeScored?: number | null, receiptDate?: string | null } | null } };

export type SessionForProductsAndServicesQueryVariables = Exact<{
  sessionId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
}>;


export type SessionForProductsAndServicesQuery = { __typename?: 'Query', session: { __typename?: 'Session', id: number, status: SessionStatus, shouldBeManagedInTasPortal?: boolean | null, scoring?: { __typename?: 'SessionScoring', status?: SessionScoringStatus | null } | null, documents?: { __typename?: 'ScoringDocuments', postMatchedStickersFileUrl?: string | null, stickersFileUrl?: string | null, scoreReportUrl?: string | null, combinedCertificateFileUrl?: string | null, combinedIPFFileUrl?: string | null, allCandidatesScoreReportUrl?: string | null, allCandidatesCertificateUrl?: string | null, allCandidatesIPFUrl?: string | null, standardScoreRosterUrl?: string | null, expressScoreRosterUrl?: string | null } | null }, appointments: Array<{ __typename?: 'Appointment', id: string, status: AppointmentStatusEnum, candidate: { __typename?: 'Candidate', identificationId?: string | null, firstName?: string | null, lastName?: string | null, productsAndServices?: Array<{ __typename?: 'CandidateProductAndService', id: number, name: string, logisticCode: string, quantity: number, translationKey: string } | null> | null, includedProductsAndServices?: Array<{ __typename?: 'CandidateIncludedProductAndService', id: number, name: string, translationKey: string, requiresScoreReport: boolean } | null> | null } }> };

export type StoredScoreQueryVariables = Exact<{
  sessionId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
  scoreId: Scalars['Int']['input'];
}>;


export type StoredScoreQuery = { __typename?: 'Query', storedScore: { __typename?: 'StoredScore', id: number, status: ScoreStatusEnum, candidate: { __typename?: 'StoredCandidate', identificationId?: string | null, dateOfBirth?: string | null, nameAtExam?: { __typename?: 'NameAtExam', firstName?: string | null, lastName: string, fullName: string } | null }, details?: Array<{ __typename?: 'ScoreType', type: string, value?: number | null } | null> | null, test?: { __typename?: 'Test', id?: number | null, formVersion?: string | null } | null, iopsScore?: { __typename?: 'IopsScore', resultNumber: number } | null } };

export type StoredScoresForSessionQueryVariables = Exact<{
  sessionId: Scalars['Int']['input'];
  businessId: Scalars['Int']['input'];
}>;


export type StoredScoresForSessionQuery = { __typename?: 'Query', storedScores: { __typename?: 'StoredScoreList', total: number, results: Array<{ __typename?: 'StoredScore', id: number, status: ScoreStatusEnum, isCpfWithMinimumCefrLevel: boolean, candidate: { __typename?: 'StoredCandidate', identificationId?: string | null, nameAtExam?: { __typename?: 'NameAtExam', firstName?: string | null, lastName: string, fullName: string } | null }, details?: Array<{ __typename?: 'ScoreType', type: string, value?: number | null } | null> | null }> } };


export const AddCommentDocument = `
    mutation AddComment($businessId: Int!, $sessionId: Int!, $comment: CommentInput!) {
  addComment(businessId: $businessId, sessionId: $sessionId, comment: $comment) {
    category
    id
    lastUpdatedAt
    message
    username
  }
}
    `;
export const useAddCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCommentMutation, TError, AddCommentMutationVariables, TContext>) =>
    useMutation<AddCommentMutation, TError, AddCommentMutationVariables, TContext>(
      ['AddComment'],
      (variables?: AddCommentMutationVariables) => fetcher<AddCommentMutation, AddCommentMutationVariables>(AddCommentDocument, variables)(),
      options
    );
export const ConfirmScoringDocument = `
    mutation confirmScoring($businessId: Int!, $plannedAt: String, $purchaseAdjustment: PurchaseAdjustmentInput, $purchaseId: Int, $scoredAt: String!, $scorerId: Int!, $scoringType: ScoringType, $sessionId: Int!) {
  confirmScoring(
    businessId: $businessId
    plannedAt: $plannedAt
    purchaseAdjustment: $purchaseAdjustment
    purchaseId: $purchaseId
    scoredAt: $scoredAt
    scorerId: $scorerId
    scoringType: $scoringType
    sessionId: $sessionId
  )
}
    `;
export const useConfirmScoringMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ConfirmScoringMutation, TError, ConfirmScoringMutationVariables, TContext>) =>
    useMutation<ConfirmScoringMutation, TError, ConfirmScoringMutationVariables, TContext>(
      ['confirmScoring'],
      (variables?: ConfirmScoringMutationVariables) => fetcher<ConfirmScoringMutation, ConfirmScoringMutationVariables>(ConfirmScoringDocument, variables)(),
      options
    );
export const DeleteCommentDocument = `
    mutation DeleteComment($businessId: Int!, $sessionId: Int!, $commentId: String!) {
  deleteComment(
    businessId: $businessId
    commentId: $commentId
    sessionId: $sessionId
  )
}
    `;
export const useDeleteCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCommentMutation, TError, DeleteCommentMutationVariables, TContext>) =>
    useMutation<DeleteCommentMutation, TError, DeleteCommentMutationVariables, TContext>(
      ['DeleteComment'],
      (variables?: DeleteCommentMutationVariables) => fetcher<DeleteCommentMutation, DeleteCommentMutationVariables>(DeleteCommentDocument, variables)(),
      options
    );
export const AuthDocument = `
    mutation auth($password: String!, $username: String!, $recaptchaToken: String!) {
  auth(password: $password, username: $username, recaptchaToken: $recaptchaToken)
}
    `;
export const useAuthMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AuthMutation, TError, AuthMutationVariables, TContext>) =>
    useMutation<AuthMutation, TError, AuthMutationVariables, TContext>(
      ['auth'],
      (variables?: AuthMutationVariables) => fetcher<AuthMutation, AuthMutationVariables>(AuthDocument, variables)(),
      options
    );
export const LogoutDocument = `
    mutation logout {
  logout
}
    `;
export const useLogoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<LogoutMutation, TError, LogoutMutationVariables, TContext>) =>
    useMutation<LogoutMutation, TError, LogoutMutationVariables, TContext>(
      ['logout'],
      (variables?: LogoutMutationVariables) => fetcher<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables)(),
      options
    );
export const GetLsdDocument = `
    mutation getLSD($businessId: Int!, $lsdInput: LSDInput!, $sessionId: Int!) {
  lsd(businessId: $businessId, lsdInput: $lsdInput, sessionId: $sessionId) {
    candidate {
      dateOfBirth
      firstName
      lastName
    }
    previousScores {
      blankAnswers
      candidateName {
        firstName
        lastName
      }
      clientData {
        clientId
        clientName
      }
      lsd {
        dateDifference
        scoreDifference
      }
      score {
        type
        value
      }
      session {
        sessionDate
        sessionId
        testingSite {
          address {
            city
            postCode
          }
        }
      }
      test {
        deliveryPlatform
        formVersion
        format
        id
        name
        open
        program
        type
      }
    }
    rowNumber
    totalScore
  }
}
    `;
export const useGetLsdMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GetLsdMutation, TError, GetLsdMutationVariables, TContext>) =>
    useMutation<GetLsdMutation, TError, GetLsdMutationVariables, TContext>(
      ['getLSD'],
      (variables?: GetLsdMutationVariables) => fetcher<GetLsdMutation, GetLsdMutationVariables>(GetLsdDocument, variables)(),
      options
    );
export const SaveScoresDocument = `
    mutation SaveScores($file: FileInput!, $businessId: Int!, $sessionId: Int!, $matchedScores: [MatchedScore!]!, $businessName: String!) {
  isSaved: saveScoreMatching(
    file: $file
    sessionId: $sessionId
    matchedScores: $matchedScores
    businessId: $businessId
    businessName: $businessName
  )
}
    `;
export const useSaveScoresMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SaveScoresMutation, TError, SaveScoresMutationVariables, TContext>) =>
    useMutation<SaveScoresMutation, TError, SaveScoresMutationVariables, TContext>(
      ['SaveScores'],
      (variables?: SaveScoresMutationVariables) => fetcher<SaveScoresMutation, SaveScoresMutationVariables>(SaveScoresDocument, variables)(),
      options
    );
export const UpdateBusinessOnAuthDocument = `
    mutation UpdateBusinessOnAuth($businessId: Int!) {
  updateCompleted: updateBusinessOnAuth(businessId: $businessId)
}
    `;
export const useUpdateBusinessOnAuthMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateBusinessOnAuthMutation, TError, UpdateBusinessOnAuthMutationVariables, TContext>) =>
    useMutation<UpdateBusinessOnAuthMutation, TError, UpdateBusinessOnAuthMutationVariables, TContext>(
      ['UpdateBusinessOnAuth'],
      (variables?: UpdateBusinessOnAuthMutationVariables) => fetcher<UpdateBusinessOnAuthMutation, UpdateBusinessOnAuthMutationVariables>(UpdateBusinessOnAuthDocument, variables)(),
      options
    );
export const UpdateCommentDocument = `
    mutation UpdateComment($businessId: Int!, $sessionId: Int!, $commentId: String!, $comment: CommentInput!) {
  updateComment(
    businessId: $businessId
    commentId: $commentId
    sessionId: $sessionId
    comment: $comment
  )
}
    `;
export const useUpdateCommentMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCommentMutation, TError, UpdateCommentMutationVariables, TContext>) =>
    useMutation<UpdateCommentMutation, TError, UpdateCommentMutationVariables, TContext>(
      ['UpdateComment'],
      (variables?: UpdateCommentMutationVariables) => fetcher<UpdateCommentMutation, UpdateCommentMutationVariables>(UpdateCommentDocument, variables)(),
      options
    );
export const UpdateScoresDocument = `
    mutation UpdateScores($businessId: Int!, $sessionId: Int!, $scores: [StoredScoreInput]!) {
  updateScores(businessId: $businessId, sessionId: $sessionId, scores: $scores) {
    ... on UpdateScoresErrorList {
      success
      errors {
        code
        error
        scoreIds
      }
    }
    ... on UpdateScoresSuccess {
      success
      scores {
        id
        status
      }
    }
  }
}
    `;
export const useUpdateScoresMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateScoresMutation, TError, UpdateScoresMutationVariables, TContext>) =>
    useMutation<UpdateScoresMutation, TError, UpdateScoresMutationVariables, TContext>(
      ['UpdateScores'],
      (variables?: UpdateScoresMutationVariables) => fetcher<UpdateScoresMutation, UpdateScoresMutationVariables>(UpdateScoresDocument, variables)(),
      options
    );
export const UpdateSessionPrintingStatusDocument = `
    mutation updateSessionPrintingStatus($businessId: Int!, $sessionId: Int!, $transition: String!) {
  updateSessionPrintingStatus(
    businessId: $businessId
    sessionId: $sessionId
    transition: $transition
  )
}
    `;
export const useUpdateSessionPrintingStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateSessionPrintingStatusMutation, TError, UpdateSessionPrintingStatusMutationVariables, TContext>) =>
    useMutation<UpdateSessionPrintingStatusMutation, TError, UpdateSessionPrintingStatusMutationVariables, TContext>(
      ['updateSessionPrintingStatus'],
      (variables?: UpdateSessionPrintingStatusMutationVariables) => fetcher<UpdateSessionPrintingStatusMutation, UpdateSessionPrintingStatusMutationVariables>(UpdateSessionPrintingStatusDocument, variables)(),
      options
    );
export const UpdateScoreDocument = `
    mutation updateScore($businessId: Int!, $fileContents: String!, $scoreId: Int!, $sessionId: Int!) {
  updateScore(
    businessId: $businessId
    sessionId: $sessionId
    scoreId: $scoreId
    fileContents: $fileContents
  ) {
    ... on UpdateScoreError {
      code
      error
      success
    }
    ... on UpdateScoreSuccess {
      success
    }
  }
}
    `;
export const useUpdateScoreMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateScoreMutation, TError, UpdateScoreMutationVariables, TContext>) =>
    useMutation<UpdateScoreMutation, TError, UpdateScoreMutationVariables, TContext>(
      ['updateScore'],
      (variables?: UpdateScoreMutationVariables) => fetcher<UpdateScoreMutation, UpdateScoreMutationVariables>(UpdateScoreDocument, variables)(),
      options
    );
export const UploadScoreDocument = `
    mutation uploadScore($businessId: Int!, $sessionId: Int!, $file: FileInput!, $context: UploadScoreContext = SCORING) {
  parseIopsFile(
    businessId: $businessId
    sessionId: $sessionId
    file: $file
    context: $context
  ) {
    __typename
    ... on UploadScoreSuccess {
      scoredCandidates {
        identificationId
        fullName
        firstName
        lastName
        dateOfBirth
        scores {
          type
          value
        }
        totalScore
        resultNumber
        rowNumber
        formCode
        qualityControl {
          identicalNameGroup
          identicalScoreGroup
          lowScore
        }
      }
      sessionCandidates {
        dateOfBirth
        fullName
        identificationId
        matching {
          externalCandidateId
          rowNumber
          reason
        }
      }
    }
    ... on UploadScoreError {
      errorCode: code
      errors {
        invalidRows
      }
    }
  }
}
    `;
export const useUploadScoreMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UploadScoreMutation, TError, UploadScoreMutationVariables, TContext>) =>
    useMutation<UploadScoreMutation, TError, UploadScoreMutationVariables, TContext>(
      ['uploadScore'],
      (variables?: UploadScoreMutationVariables) => fetcher<UploadScoreMutation, UploadScoreMutationVariables>(UploadScoreDocument, variables)(),
      options
    );
export const GetSessionDetailsDocument = `
    query getSessionDetails($businessId: Int!, $sessionId: Int!) {
  loadSessionForScoring(businessId: $businessId, sessionId: $sessionId) {
    id
    scheduledAt
    business {
      id
      name
      erpId
      status
    }
    country {
      timezone
    }
    isCmd
    status
    comments {
      category
      id
      lastUpdatedAt
      message
      username
    }
    testType {
      formVersion
      open
      name
      translationKey
      isPbt
    }
    scoring {
      iopsNumber
      scoredAt
      status
    }
    scoringType
    purchase {
      id
    }
    totalScores
    testingSite {
      name
      address {
        country {
          name
        }
      }
    }
    resultsShippingAddress {
      city
      company
      postCode
      state
      streetLine1
      streetLine2
      country {
        name
      }
      contact {
        name
        phoneNumber
        email
      }
    }
    logisticsPlannedDatesDocsDelivery {
      standardAt
      expressAt
      superExpressAt
    }
    logisticsReceived {
      quantityAnswerSheetsToBeScored
      receiptDate
    }
    expectedCandidates
  }
}
    `;
export const useGetSessionDetailsQuery = <
      TData = GetSessionDetailsQuery,
      TError = unknown
    >(
      variables: GetSessionDetailsQueryVariables,
      options?: UseQueryOptions<GetSessionDetailsQuery, TError, TData>
    ) =>
    useQuery<GetSessionDetailsQuery, TError, TData>(
      ['getSessionDetails', variables],
      fetcher<GetSessionDetailsQuery, GetSessionDetailsQueryVariables>(GetSessionDetailsDocument, variables),
      options
    );
export const GetSessionsAllowedToPrintDocument = `
    query getSessionsAllowedToPrint($businessId: Int!, $filters: SessionPrintingFiltersInput, $limit: Int!, $offset: Int!, $sort: SortInput!) {
  getSessionsAllowedToPrint(
    businessId: $businessId
    filters: $filters
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    total
    results {
      id
      scheduledAt
      country {
        timezone
      }
      testType {
        isCbt
        name
        translationKey
      }
    }
  }
}
    `;
export const useGetSessionsAllowedToPrintQuery = <
      TData = GetSessionsAllowedToPrintQuery,
      TError = unknown
    >(
      variables: GetSessionsAllowedToPrintQueryVariables,
      options?: UseQueryOptions<GetSessionsAllowedToPrintQuery, TError, TData>
    ) =>
    useQuery<GetSessionsAllowedToPrintQuery, TError, TData>(
      ['getSessionsAllowedToPrint', variables],
      fetcher<GetSessionsAllowedToPrintQuery, GetSessionsAllowedToPrintQueryVariables>(GetSessionsAllowedToPrintDocument, variables),
      options
    );
export const GetSessionsAllowedToScoreDocument = `
    query getSessionsAllowedToScore($businessId: Int!, $filters: SessionScoringFiltersInput, $limit: Int!, $offset: Int!, $sort: SortInput!) {
  getSessionsAllowedToScore(
    businessId: $businessId
    filters: $filters
    limit: $limit
    offset: $offset
    sort: $sort
  ) {
    total
    results {
      id
      status
      business {
        id
        name
      }
      scheduledAt
      country {
        name
        timezone
      }
      testType {
        id
        name
        translationKey
      }
      purchase {
        id
      }
    }
  }
}
    `;
export const useGetSessionsAllowedToScoreQuery = <
      TData = GetSessionsAllowedToScoreQuery,
      TError = unknown
    >(
      variables: GetSessionsAllowedToScoreQueryVariables,
      options?: UseQueryOptions<GetSessionsAllowedToScoreQuery, TError, TData>
    ) =>
    useQuery<GetSessionsAllowedToScoreQuery, TError, TData>(
      ['getSessionsAllowedToScore', variables],
      fetcher<GetSessionsAllowedToScoreQuery, GetSessionsAllowedToScoreQueryVariables>(GetSessionsAllowedToScoreDocument, variables),
      options
    );
export const GetUsersForBusinessDocument = `
    query getUsersForBusiness($businessId: Int!, $roles: [UserRolesEnum!], $sort: SortInput) {
  getUsersForBusiness(businessId: $businessId, roles: $roles, sort: $sort) {
    fullname
    id
  }
}
    `;
export const useGetUsersForBusinessQuery = <
      TData = GetUsersForBusinessQuery,
      TError = unknown
    >(
      variables: GetUsersForBusinessQueryVariables,
      options?: UseQueryOptions<GetUsersForBusinessQuery, TError, TData>
    ) =>
    useQuery<GetUsersForBusinessQuery, TError, TData>(
      ['getUsersForBusiness', variables],
      fetcher<GetUsersForBusinessQuery, GetUsersForBusinessQueryVariables>(GetUsersForBusinessDocument, variables),
      options
    );
export const MeDocument = `
    query me {
  me {
    id
    email
    firstname
    lastname
    preferredLanguage
    businessId
    businessName
    roles
    isB2B
  }
}
    `;
export const useMeQuery = <
      TData = MeQuery,
      TError = unknown
    >(
      variables?: MeQueryVariables,
      options?: UseQueryOptions<MeQuery, TError, TData>
    ) =>
    useQuery<MeQuery, TError, TData>(
      variables === undefined ? ['me'] : ['me', variables],
      fetcher<MeQuery, MeQueryVariables>(MeDocument, variables),
      options
    );
export const NumberOfIopsRowsAndPendingScoresDocument = `
    query numberOfIopsRowsAndPendingScores($businessId: Int!, $sessionId: Int!) {
  numberOfIopsRowsAndPendingScores(businessId: $businessId, sessionId: $sessionId) {
    numberOfRows
    pendingScores
  }
}
    `;
export const useNumberOfIopsRowsAndPendingScoresQuery = <
      TData = NumberOfIopsRowsAndPendingScoresQuery,
      TError = unknown
    >(
      variables: NumberOfIopsRowsAndPendingScoresQueryVariables,
      options?: UseQueryOptions<NumberOfIopsRowsAndPendingScoresQuery, TError, TData>
    ) =>
    useQuery<NumberOfIopsRowsAndPendingScoresQuery, TError, TData>(
      ['numberOfIopsRowsAndPendingScores', variables],
      fetcher<NumberOfIopsRowsAndPendingScoresQuery, NumberOfIopsRowsAndPendingScoresQueryVariables>(NumberOfIopsRowsAndPendingScoresDocument, variables),
      options
    );
export const ScoringValidationDefaultsDocument = `
    query scoringValidationDefaults($businessId: Int!, $scoringType: ScoringType!, $sessionId: Int!, $purchaseId: Int, $isNumberMode: Boolean) {
  scoringValidationDefaults(
    businessId: $businessId
    scoringType: $scoringType
    sessionId: $sessionId
    purchaseId: $purchaseId
    isNumberMode: $isNumberMode
  ) {
    plannedDates {
      availableDates
      defaultDate
    }
    adjustedProducts {
      id
      decrease
      increase
      isDigital
      productTranslationKey
      quantity
      unitPrice
    }
    purchase {
      isAwaitingInvoicingOrBilled
      isEditable
    }
    originalPurchasedTestTypeQuantity
    realCandidatesNo
    candidatesCPFWithScoreUnderA2No
  }
}
    `;
export const useScoringValidationDefaultsQuery = <
      TData = ScoringValidationDefaultsQuery,
      TError = unknown
    >(
      variables: ScoringValidationDefaultsQueryVariables,
      options?: UseQueryOptions<ScoringValidationDefaultsQuery, TError, TData>
    ) =>
    useQuery<ScoringValidationDefaultsQuery, TError, TData>(
      ['scoringValidationDefaults', variables],
      fetcher<ScoringValidationDefaultsQuery, ScoringValidationDefaultsQueryVariables>(ScoringValidationDefaultsDocument, variables),
      options
    );
export const LoadSessionForScoringDocument = `
    query loadSessionForScoring($businessId: Int!, $sessionId: Int!) {
  loadSessionForScoring(businessId: $businessId, sessionId: $sessionId) {
    business {
      id
      name
    }
    country {
      name
      timezone
    }
    canHaveExternalCandidateIdInIopsFile
    shouldBeManagedInTasPortal
    hasCandidateIdInIopsFile
    id
    isCmd
    isOpen
    scoringType
    isNumberMode
    scheduledAt
    endAt
    status
    scoring {
      status
    }
    testType {
      formVersion
      id
      name
      open
      lsdThreshold
      lsdFamily
      isCbt
    }
    purchase {
      id
    }
    printing {
      status
    }
    logisticsReceived {
      quantityAnswerSheetsToBeScored
      receiptDate
    }
  }
}
    `;
export const useLoadSessionForScoringQuery = <
      TData = LoadSessionForScoringQuery,
      TError = unknown
    >(
      variables: LoadSessionForScoringQueryVariables,
      options?: UseQueryOptions<LoadSessionForScoringQuery, TError, TData>
    ) =>
    useQuery<LoadSessionForScoringQuery, TError, TData>(
      ['loadSessionForScoring', variables],
      fetcher<LoadSessionForScoringQuery, LoadSessionForScoringQueryVariables>(LoadSessionForScoringDocument, variables),
      options
    );
export const SessionForProductsAndServicesDocument = `
    query SessionForProductsAndServices($sessionId: Int!, $businessId: Int!) {
  session: loadSessionForScoring(sessionId: $sessionId, businessId: $businessId) {
    id
    scoring {
      status
    }
    status
    documents {
      postMatchedStickersFileUrl
      stickersFileUrl
      scoreReportUrl
      combinedCertificateFileUrl
      combinedIPFFileUrl
      allCandidatesScoreReportUrl
      allCandidatesCertificateUrl
      allCandidatesIPFUrl
      standardScoreRosterUrl
      expressScoreRosterUrl
    }
    shouldBeManagedInTasPortal
  }
  appointments: appointmentsForScoring(
    sessionId: $sessionId
    businessId: $businessId
  ) {
    id
    status
    candidate {
      identificationId
      firstName
      lastName
      productsAndServices {
        id
        name
        logisticCode
        quantity
        translationKey
      }
      includedProductsAndServices {
        id
        name
        translationKey
        requiresScoreReport
      }
    }
  }
}
    `;
export const useSessionForProductsAndServicesQuery = <
      TData = SessionForProductsAndServicesQuery,
      TError = unknown
    >(
      variables: SessionForProductsAndServicesQueryVariables,
      options?: UseQueryOptions<SessionForProductsAndServicesQuery, TError, TData>
    ) =>
    useQuery<SessionForProductsAndServicesQuery, TError, TData>(
      ['SessionForProductsAndServices', variables],
      fetcher<SessionForProductsAndServicesQuery, SessionForProductsAndServicesQueryVariables>(SessionForProductsAndServicesDocument, variables),
      options
    );
export const StoredScoreDocument = `
    query StoredScore($sessionId: Int!, $businessId: Int!, $scoreId: Int!) {
  storedScore(sessionId: $sessionId, businessId: $businessId, scoreId: $scoreId) {
    id
    status
    candidate {
      identificationId
      nameAtExam {
        firstName
        lastName
        fullName
      }
      dateOfBirth
    }
    details {
      type
      value
    }
    test {
      id
      formVersion
    }
    iopsScore {
      resultNumber
    }
  }
}
    `;
export const useStoredScoreQuery = <
      TData = StoredScoreQuery,
      TError = unknown
    >(
      variables: StoredScoreQueryVariables,
      options?: UseQueryOptions<StoredScoreQuery, TError, TData>
    ) =>
    useQuery<StoredScoreQuery, TError, TData>(
      ['StoredScore', variables],
      fetcher<StoredScoreQuery, StoredScoreQueryVariables>(StoredScoreDocument, variables),
      options
    );
export const StoredScoresForSessionDocument = `
    query StoredScoresForSession($sessionId: Int!, $businessId: Int!) {
  storedScores(sessionId: $sessionId, businessId: $businessId) {
    total
    results {
      id
      status
      isCpfWithMinimumCefrLevel
      candidate {
        identificationId
        nameAtExam {
          firstName
          lastName
          fullName
        }
      }
      details {
        type
        value
      }
    }
  }
}
    `;
export const useStoredScoresForSessionQuery = <
      TData = StoredScoresForSessionQuery,
      TError = unknown
    >(
      variables: StoredScoresForSessionQueryVariables,
      options?: UseQueryOptions<StoredScoresForSessionQuery, TError, TData>
    ) =>
    useQuery<StoredScoresForSessionQuery, TError, TData>(
      ['StoredScoresForSession', variables],
      fetcher<StoredScoresForSessionQuery, StoredScoresForSessionQueryVariables>(StoredScoresForSessionDocument, variables),
      options
    );
export const namedOperations = {
  Query: {
    getSessionDetails: 'getSessionDetails',
    getSessionsAllowedToPrint: 'getSessionsAllowedToPrint',
    getSessionsAllowedToScore: 'getSessionsAllowedToScore',
    getUsersForBusiness: 'getUsersForBusiness',
    me: 'me',
    numberOfIopsRowsAndPendingScores: 'numberOfIopsRowsAndPendingScores',
    scoringValidationDefaults: 'scoringValidationDefaults',
    loadSessionForScoring: 'loadSessionForScoring',
    SessionForProductsAndServices: 'SessionForProductsAndServices',
    StoredScore: 'StoredScore',
    StoredScoresForSession: 'StoredScoresForSession'
  },
  Mutation: {
    AddComment: 'AddComment',
    confirmScoring: 'confirmScoring',
    DeleteComment: 'DeleteComment',
    auth: 'auth',
    logout: 'logout',
    getLSD: 'getLSD',
    SaveScores: 'SaveScores',
    UpdateBusinessOnAuth: 'UpdateBusinessOnAuth',
    UpdateComment: 'UpdateComment',
    UpdateScores: 'UpdateScores',
    updateSessionPrintingStatus: 'updateSessionPrintingStatus',
    updateScore: 'updateScore',
    uploadScore: 'uploadScore'
  }
}